/* eslint-disable @typescript-eslint/no-explicit-any */
import * as actionTypes from './actionTypes';

function reducer(state:{ readEventNotifications: [], events: [] }, action:{ payload: any, type: string }) {
  switch (action.type) {
    case actionTypes.SET_EVENTS:
      return {
        ...state,
        events:  action.payload,
      };

    case actionTypes.APPEND_EVENTS:
      return {
        ...state,
        events:  [...state.events, ...action.payload],
      };

    case actionTypes.SET_NO_MORE_EVENT:
      return {
        ...state,
        noMoreEvent:  action.payload,
      };

    case actionTypes.SET_EVENT_FILTERS:
      return {
        ...state,
        eventFilters: action.payload,
      };

    case actionTypes.SET_EVENT_NOTIFICATIONS:
      return {
        ...state,
        eventNotifications: action.payload,
      };
  
    case actionTypes.SET_EVENT_STATE:
      return {
        ...state,
        eventState: action.payload,
      };

    case actionTypes.SET_NOTIFICATION_AS_READ:
      return {
        ...state,
        readEventNotifications: [...state.readEventNotifications, action.payload],
      };

    case actionTypes.SET_READ_EVENT_NOTIFICATIONS:
      return {
        ...state,
        readEventNotifications: action.payload,
      };
      
    default:
      return state;
  }
}

export default reducer;
